export default __webpack_public_path__ + "static/media/single-sensor-chart.8e2e47be.svg";